import { Link } from 'react-router-dom';
import { Container } from '../components/ui/Container';
import { Eyebrow } from '../components/ui/Eyebrow';

export function NotFoundPage() {
  return (
    <Container className="py-32 text-center">
      <Eyebrow>404</Eyebrow>
      <h1 className="mt-4 font-serif text-4xl font-light text-ink md:text-5xl">
        Page not found
      </h1>
      <p className="mx-auto mt-6 max-w-md text-sm leading-relaxed text-stone">
        The page you're looking for doesn't exist or may have moved. Try browsing our collection instead.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="bg-ink px-7 py-3 text-[13px] font-semibold uppercase tracking-[0.14em] text-cream transition-colors hover:bg-clay"
        >
          Go Home
        </Link>
        <Link
          to="/categories/wall-art"
          className="border border-ink px-7 py-3 text-[13px] font-semibold uppercase tracking-[0.14em] text-ink transition-colors hover:bg-ink hover:text-cream"
        >
          Shop All Prints
        </Link>
      </div>
    </Container>
  );
}
